// extracted by mini-css-extract-plugin
export var avatar = "_no-3";
export var avatarContainer = "_no-2";
export var avatarSpacer = "_no-5";
export var avatarSpacerContainer = "_no-4";
export var avatarStackContainer = "_no-1";
export var bubble = "_no-0";
export var remainderBubble = "_no-6";